import axios from 'axios'
import $store from '@/store'
import {
  camelCaseKeys,
  // snakeCaseKeys
} from '@/util'
import { setError } from './errorParser'

const _axios = axios.create({
  baseURL: `${process.env.common.defaultApi.host}/api`,
})

_axios.interceptors.request.use(
  async (config) => {
    await $store.dispatch('auth/sync')
    if (config.isInterceptor !== false) {
      if (
        config.headers.Authorization == null ||
        config.headers.Authorization.startsWith('Basic') === false
      ) {
        const token = $store.state.auth.token
        if (token != null) {
          config.headers.Authorization = `JWT ${token}`
        }
      }
    }
    // snakeCaseKeys 강제변환
    // console.log(config, config.data)
    // if (config.convert !== false) {
    //  config.data = snakeCaseKeys(config.data)
    // }
    return config
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  },
)

_axios.interceptors.response.use(
  (resp) => {
    return Promise.resolve(camelCaseKeys(resp))
  },
  async (error) => {
    const { response } = error
    if (response?.status === 403) {
      $store.dispatch('auth/signout')
    }
    const errorResponse = setError(response)
    return Promise.reject(camelCaseKeys(errorResponse))
  },
)

export default _axios
